document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('[data-filter]');
  const cards = document.querySelectorAll('[data-category]');
  const counts = document.querySelectorAll('[data-count]');
  
  // Calculate counts
  const categoryCountMap = { all: cards.length };
  cards.forEach(card => {
    const cat = card.dataset.category;
    categoryCountMap[cat] = (categoryCountMap[cat] || 0) + 1;
  });
  
  // Update count badges
  counts.forEach(el => {
    const cat = el.dataset.count;
    el.textContent = categoryCountMap[cat] || 0;
  });
  
  // Featured carousel
  const carousel = document.querySelector('[data-featured-carousel]');
  if (carousel) {
    const track = carousel.querySelector('.gallery-featured__track');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');

    if (track && prevBtn && nextBtn) {
      const getScrollAmount = () => {
        const card = track.querySelector('.gallery-featured__card');
        return card ? card.offsetWidth + 20 : 400;
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });

      const updateNav = () => {
        prevBtn.style.opacity = track.scrollLeft <= 10 ? '0.3' : '1';
        prevBtn.style.pointerEvents = track.scrollLeft <= 10 ? 'none' : 'auto';
        const atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 10;
        nextBtn.style.opacity = atEnd ? '0.3' : '1';
        nextBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
      };

      track.addEventListener('scroll', updateNav, { passive: true });
      updateNav();
    }
  }
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const filter = tab.dataset.filter;
      
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      
      cards.forEach(card => {
        if (filter === 'all' || card.dataset.category === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });
});